import Vue from 'vue'
import Vuex from 'vuex'
import settings from './settings'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    geoportals: undefined,
    gminy: undefined,
    currentLanguage: 'pl'
  },
  mutations: {
    setGeoportals (state, newValue) {
      state.geoportals = newValue
    },
    setGminy (state, newValue) {
      state.gminy = newValue
    }
  },
  actions: {
    loadGeoportals (context, { config, filePath }) {
      axios.get(filePath)
        .then((response) => {
          if (config === 'geoportals') {
            context.commit('setGeoportals', response.data)
          } else if (config === 'gminy') {
            context.commit('setGminy', response.data)
          }
        }, (error) => {
          console.error(error)
        })
    }
  },
  modules: {
    settings: settings
  }
})
